import { Col, DatePicker, notification, Row, Select, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { allPaymentsApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";
import { setHeaderName } from "../../services/SetHeaderName";
import { rupees } from "./PlanOptions";

const STATUS_COLORS = { paid: 'green', created: 'gold', failed: 'default' }
const STATUS_LABELS = { paid: 'Paid', created: 'Pending', failed: 'Not completed' }

// admin: who paid for which plan and how much (view only)
export const AdminPayments = () => {
    const [range, setRange] = useState([moment().startOf('month'), moment()])
    const [status, setStatus] = useState('paid')
    const [rows, setRows] = useState([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setHeaderName('Payments')
    }, [])

    useEffect(() => {
        setLoading(true)
        allPaymentsApi({
            from: range?.[0]?.format('YYYY-MM-DD'),
            to: range?.[1]?.format('YYYY-MM-DD'),
            status: status || undefined,
        })
            .then((res) => {
                setRows(res.data.data)
                setTotal(res.data.total_paid)
            })
            .catch((err) => notification.error({ message: apiErrorMessage(err) }))
            .finally(() => setLoading(false))
    }, [range, status])

    return (
        <div className="AdminPayments">
            <Row gutter={[12, 12]} className="mb-3" align="middle">
                <Col><DatePicker.RangePicker value={range} onChange={setRange} format="DD-MM-YYYY" /></Col>
                <Col>
                    <Select value={status} onChange={setStatus} style={{ width: 170 }}>
                        <Select.Option value="paid">Paid</Select.Option>
                        <Select.Option value="created">Pending</Select.Option>
                        <Select.Option value="failed">Not completed</Select.Option>
                        <Select.Option value="">All</Select.Option>
                    </Select>
                </Col>
                <Col flex="auto" className="text-end">
                    <h6 className="mb-0">Received: {rupees(total)} ({rows.filter((r) => r.status === 'paid').length} payments)</h6>
                </Col>
            </Row>
            <Table
                rowKey="id"
                loading={loading}
                dataSource={rows}
                scroll={{ x: 'max-content' }}
                locale={{ emptyText: 'No payments in these dates' }}
                columns={[
                    { title: 'Date', key: 'date', render: (_, row) => moment(row.paid_at || row.created_at).format('DD MMM YYYY, hh:mm A') },
                    {
                        title: 'Doctor', key: 'doctor', render: (_, row) => (
                            <><div>{row.doctor}</div><div className="text-muted" style={{ fontSize: 12 }}>{row.doctor_email}</div></>
                        ),
                    },
                    { title: 'Plan', dataIndex: 'plan' },
                    { title: 'Billing', dataIndex: 'billing_cycle', render: (cycle) => cycle.charAt(0).toUpperCase() + cycle.slice(1) },
                    { title: 'Amount', dataIndex: 'amount', render: (amount, row) => (row.set_by ? <Tag color="purple">Set by {row.set_by}</Tag> : rupees(amount)) },
                    { title: 'Credit used', dataIndex: 'credit_applied', render: (credit) => (credit ? rupees(credit) : '-') },
                    { title: 'Status', dataIndex: 'status', render: (value) => <Tag color={STATUS_COLORS[value]}>{STATUS_LABELS[value] || value}</Tag> },
                    { title: 'Razorpay payment', dataIndex: 'razorpay_payment_id', render: (id, row) => <span className="text-muted">{row.set_by ? (row.note || 'No payment') : id || row.razorpay_order_id}</span> },
                ]}
            />
        </div>
    )
}
